// extracted by mini-css-extract-plugin
export default {"globalIcons":"icons_globalIcons__3ORNv"};